import { CommentsIcon, LikeIcon, LinkArrowIcon, PalyListIcon, VideoImage, ViewsIcon } from 'assets'
import { CustomModal, Loader, VideoPlayer } from 'components'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { getVideoDetailsByIdAction } from 'store/action/videoReducer'
import { createImageUrl } from 'utils/createImageUrl'
import { formatNumber } from 'utils/formatNumber'
import { removeUtcFormate } from 'utils/removeUtcFormate'

function VideoDetails() {
   const settingData = useSelector((state) => state.settings)
   const { selectedChannelID } = settingData

   const videoRedux = useSelector((state) => state.videoRedux)
   const {
      loading,
      videoDetailsLoader,
      videoDetails: videoDetailsData,
      loadMoreComments
   } = videoRedux
   const params = useParams()
   const dispatch = useDispatch()
   const [showMore, setShowMore] = useState(false)
   const [isLongText, setIsLongText] = useState(false)
   const [openShowMoreModal, setOpenShowMoreModal] = useState(false)
   const [openVideoModal, setOpenVideoModal] = useState(false)
   const location = useLocation()

   const onCloseModal = () => {
      setOpenShowMoreModal(!openShowMoreModal)
   }

   useEffect(() => {
      if (videoDetailsData?.description) {
         setIsLongText(videoDetailsData?.description.length > 250)
      }
      return () => {}
   }, [videoDetailsData])

   useEffect(() => {
      if (loadMoreComments) {
         dispatch(
            getVideoDetailsByIdAction({ channel_id: selectedChannelID, video_id: params?.id })
         )
      }
      return () => {}
   }, [loadMoreComments])

   const onCloseVideoModal = () => {
      setOpenVideoModal(false)
   }

   return (
      <div>
         {(videoDetailsLoader || loading) && (
            <Loader message={location.state?.loadingMessage || ''} />
         )}
         <div className="card">
            <div className="video-details-section">
               <div className="row">
                  <div className="col-lg-3">
                     <div
                        className="video-image"
                        onClick={() => {
                           setOpenVideoModal(true)
                        }}>
                        {!videoDetailsLoader && (
                           <img
                              src={
                                 videoDetailsData?.thumbnails
                                    ? createImageUrl(videoDetailsData?.thumbnails)
                                    : VideoImage
                              }
                              alt="channel-image"
                              className="mw-100"
                           />
                        )}
                     </div>
                  </div>
                  <div className="col-lg-9">
                     <div className="video-desc">
                        <div className="video-name-section">
                           <div className="video-name-wrap">
                              <h3 className="at-text-dark">{videoDetailsData?.title}</h3>
                              <p
                                 className="at-text-light"
                                 style={{ fontSize: '12px', color: '#FF423D' }}>
                                 {videoDetailsData?.published_at
                                    ? dayjs(
                                         removeUtcFormate(videoDetailsData?.published_at)
                                      ).format('D MMMM, YYYY')
                                    : ''}
                              </p>
                           </div>
                           <div
                              className="channel-btn"
                              onClick={() => {
                                 window.open(videoDetailsData?.url)
                              }}>
                              <span>View Video</span>
                              <LinkArrowIcon />
                           </div>
                        </div>
                        <p className="mt-2 at-text-light" style={{ fontWeight: '400' }}>
                           {(videoDetailsData?.description && showMore) || !isLongText ? (
                              videoDetailsData?.description
                           ) : (
                              <>
                                 {videoDetailsData?.description.substring(0, 300)}
                                 <span
                                    className="show-more-text"
                                    onClick={() => {
                                       setOpenShowMoreModal(true)
                                    }}>
                                    ...Show more
                                 </span>
                              </>
                           )}
                        </p>
                        <div className="channel-counter mt-3">
                           <div className="row">
                              <div className="col-12 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <ViewsIcon />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {formatNumber(videoDetailsData?.video_views || 0, 2)}
                                          </p>
                                          <span className="at-text-light">VIEWS</span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <CommentsIcon />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {formatNumber(videoDetailsData?.comment_count || 0, 2)}
                                          </p>
                                          <span className="at-text-light">COMMENTS</span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                              <div className="col-12 col-lg-4">
                                 <div className="channel-count-wrap">
                                    <div className="count-logo">
                                       <LikeIcon />
                                    </div>
                                    <div className="counter-desc">
                                       <div>
                                          <p className="at-text-dark">
                                             {' '}
                                             {formatNumber(videoDetailsData?.video_likes || 0, 2)}
                                          </p>
                                          <span className="at-text-light">LIKES</span>
                                       </div>
                                       {/* <div className="counter-per">+5,9%</div> */}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         {openVideoModal && (
            <VideoPlayer
               onClose={onCloseVideoModal}
               openVideoModal={openVideoModal}
               videoId={videoDetailsData?.video_id}
            />
         )}
         {openShowMoreModal && (
            <CustomModal
               show={openShowMoreModal}
               title={'Description'}
               closeModal={onCloseModal}
               centered
               scrollable
               size={'lg'}>
               <div>{videoDetailsData?.description}</div>
            </CustomModal>
         )}
      </div>
   )
}

export default VideoDetails
